import { render, staticRenderFns } from "./referral-partner-graphic.vue?vue&type=template&id=d494da52&scoped=true&"
var script = {}
import style0 from "./referral-partner-graphic.vue?vue&type=style&index=0&id=d494da52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d494da52",
  null
  
)

export default component.exports